module.exports = __webpack_public_path__ + "img/Weapon_173.997d94cb.png";